<template>
    <div>
        <v-container fluid :style="{ 'min-height': '1000px' }">
            <v-container class="contain-width">

                <v-row>
                    <v-col
                            cols="12"
                        md="8"
                        offset-md="2"
                        lg="6"
                        offset-lg="3"
                    >

                        <h1 class="mt-6 mb-6">{{ $t('headings.Activate tags') }}</h1>

                      <div v-if="isLoggedIn">

                        <p>{{ $t('Enter the code for your activ8 product to activate it, then assign the tags to yourself or a dependant') }}.</p>
                        <ValidationObserver ref="scanObserver">
                          <v-form v-model="valid" @submit.prevent="handleSubmit">
                            <ValidationProvider name="code" rules="required" v-slot="{ errors }">
                              <v-text-field
                                  v-model="code"
                                  :error-messages="errors[0]"
                                  :label="$t('labels.Code')"
                                  required
                              ></v-text-field>
                            </ValidationProvider>
                          </v-form>

                          <div class="d-flex justify-end">
                            <v-btn rounded elevation="0" color="primary" class="small" @click="handleSubmit">{{ $t('buttons.Activate') }}</v-btn>
                          </div>

                        </ValidationObserver>



                        <v-dialog v-model="dialog" max-width="600px">
                          <v-card
                              class="mx-auto"
                          >
                            <v-card-title>{{ $t('headings.Assign tag') }}</v-card-title>
                            <v-card-text>
                              <ValidationObserver ref="activateObserver">
                                <v-form @submit.prevent="handleActivate">
                                  <ValidationProvider v-if="dependants.length > 0" vid="myself" name="Myself" rules="required">
                                    <v-checkbox v-model="myself" :label="$t('labels.Assign to myself')" required></v-checkbox>
                                  </ValidationProvider>
                                  <ValidationProvider vid="is_public" name="Public" rules="required">
                                    <div class="d-flex">
                                      <v-checkbox v-model="is_public" :label="$t('labels.Make this tag public')" required></v-checkbox>
                                      <v-tooltip max-width="400" bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-icon
                                              color="primary"
                                              dark
                                              v-bind="attrs"
                                              v-on="on"
                                              class="ml-3"
                                          >
                                            mdi-information
                                          </v-icon>
                                        </template>
                                        <span>{{ $t('Make this tag public to allow any member of the public to scan and return your property') }}. {{ $t('When a public tag is scanned, the finder may contact you by email to arrange the return') }}. {{ $t('Your email address will not be viewable to the finder') }}.</span>
                                      </v-tooltip>
                                    </div>
                                  </ValidationProvider>
                                  <ValidationProvider v-if="dependants.length > 0" vid="dependant" name="Dependant" :rules="`${myself ? '' : 'required'}`" v-slot="{ errors }">
                                    <v-autocomplete
                                        :items="dependants"
                                        item-text="name"
                                        item-value="id"
                                        v-model="dependant"
                                        :error-messages="errors[0]"
                                        :label="$t('labels.Dependant')"
                                        clearable
                                        persistent-hint
                                        :hint="$t('hints.Select a dependant to assign the tag to')"
                                        @change="setIfPublic($event)"
                                    ></v-autocomplete>
                                  </ValidationProvider>
                                  <v-row>
                                    <v-col>
                                      <v-btn class="mt-6" color="primary" @click="handleActivate">Assign</v-btn>
                                    </v-col>
                                  </v-row>
                                </v-form>
                              </ValidationObserver>
                            </v-card-text>
                            <v-card-actions>
                              <div class="flex-grow-1"></div>
                              <v-btn class="small" color="blue darken-1" text @click="dialog = false">{{ $t('buttons.Close') }}</v-btn>
                            </v-card-actions>
                          </v-card>

                        </v-dialog>

                      </div>
                      <div v-else>
                        <h2 class="mt-6 mb-6">What would you like to do?</h2>
                        <div class="">
                          <p class="text-left scenario">I am a current member and need to activate my tags:</p>
                          <v-btn color="primary" rounded elevation="0" block x-large @click="loginAndActivate">Login and activate tags</v-btn>
                          <p class="text-left scenario mt-10">I have some free tags to activate:</p>
                          <v-btn color="primary" rounded elevation="0" block x-large @click="$router.push({name: 'intro-activate'})">Create intro membership<br>and activate tags</v-btn>
                          <p class="text-left scenario mt-10">I have a product with tags pre-attached:</p>
                          <v-btn color="primary" rounded elevation="0" block x-large @click="$router.push({name: 'intro-activate'})">Create intro membership<br>and activate tags</v-btn>
                        </div>
                      </div>

                      <h2 class="mt-16 mb-6">How to activate your smart tags</h2>

                      <vimeo-player ref="player" video-id="1008398481" @ready="onReady" class="player-container mt-6 mb-12" :options="options"></vimeo-player>

                      <ol>
                        <li>To activate a non-personalised tag, scan the QR code on your product by using the camera on your mobile phone.
                          Alternatively, you can visit our website, login or setup your account, and navigate to the 'activate tags' page.</li>
                        <li>When prompted enter the unique activ8 code shown on your product. (If you scanned the QR code using the camera on your mobile phone, these details are already be prefilled).</li>
                        <li>Follow the on-screen instructions and complete the required fields by assigning the tag to yourself or another individual associated with you. Your tag is now assigned and ready for use.</li>
                        <li>Securely attach your smart tags to your items. For detailed instructions on using your iron-on smart tags, please <router-link
                            :to="{ name: 'guide', params: {slug: 'ironing-on-tags'}  }"
                            exact
                        >refer to our guide</router-link>. Now you are ready to go!</li>
                      </ol>

                      <!--                      <p class="text-center mt-6">-->
                      <!--                        <v-img-->
                      <!--                            :src="require('@/assets/activate-phone.png')"-->
                      <!--                            class="mb-6 d-inline-block"-->
                      <!--                            style="margin-top: 0px"-->
                      <!--                            width="300px"-->
                      <!--                            alt="Activate page on mobile device"-->
                      <!--                        ></v-img>-->
                      <!--                      </p>-->




                    </v-col>
              </v-row>
          </v-container>
      </v-container>
      <Footer />
  </div>

</template>

<script>

    import { tagService, userService } from '../services';
    import {mapState, mapActions, mapGetters} from 'vuex'
    import { store } from '../store';
    import { extend } from 'vee-validate';
    import { is } from 'vee-validate/dist/rules';

    import Footer from './Footer.vue'
    import {i18n} from "../i18n";

    // Add the required rule
    extend('is', is);

    export default {
        name: "Activate",
        props: ['qrCode'],
        metaInfo () {
          return {
            title: this.capitalizeFirstLetter(this.brand) + ' - ' + 'Activ8',
            htmlAttrs: {
              lang: i18n.locale
            },
            meta: [
              {
                name: 'description',
                content: i18n.t('Enter the code for your activ8 product to activate it, then assign the tags to yourself or a dependant')
              }
            ]
          }
        },
        components: {
            'Footer': Footer
        },
        data: () => ({
            dialog: false,
            code: '',
            valid: false,
            tag: {},
            dependant: '',
            myself: false,
            is_public: true,
            options: {'responsive': true, 'dnt': true},
            playerReady: false
        }),
        mounted () {

            window.scrollTo(0,0);

            window.prerenderReady = true;

            if (this.qrCode) {
              this.code = this.qrCode
            }

            if (this.dependants.length === 0) {
              this.myself = true
            }
        },
        watch: {
            myself (val) {
                if (val) {
                    this.dependant = null;

                    if (this.user.make_tags_public) {
                      this.is_public = true
                    }
                }
                else if (!this.dependant) {
                  this.is_public = false
                }
            },
            dependant (val) {
                if (val) {
                    this.myself = false;
                }
            },
        },
        computed: {
            ...mapGetters('account', ['loggedIn']),
            ...mapState({
                dependants: state => state.account.user.dependants,
                user: state => state.account.user,
                locale: state => state.locale,
                brand: state => state.brand,
                brandName: state => state.brandName
            }),
            getBackground() {
              if (this.brand === 'neotag') {
                return require('@/assets/neotag-background.jpg')
              }
              else {
                return require('@/assets/neotag-background.jpg')
              }
            },
            tagDetails () {
                return this.tag
            },
            isLoggedIn () {
              return this.loggedIn
            },
        },
        methods: {
            loginAndActivate() {
              store.dispatch('lastRoute', 'activate')
              this.$router.push({name: 'login'})
            },
            capitalizeFirstLetter(string) {
              return string.charAt(0).toUpperCase() + string.slice(1);
            },
            setIfPublic(event) {

              if (event) {
                let dependant = this.dependants.find(item=>item.id==event);
                if (dependant.make_tags_public) {
                  this.is_public = true
                }
                else {
                  this.is_public = false
                }
              }


            },
            onChange(event, index) {
                if (event, index) {
                    let dependant = this.dependants.find(item=>item.id==event);
                    this.dependant = dependant
                }
            },
            handleSubmit () {

                this.tag = [];
                this.found = false;
                store.dispatch('alert/clear');

                const { code } = this;

                let codeString = code;

                let observer = this.$refs.scanObserver;

                observer.validate().then(success => {
                    if (!success) {
                        return;
                    }

                    let n = code.lastIndexOf('/');
                    if (n >= 0) {
                        codeString = code.substring(n + 1);
                    }

                    tagService.findUnactivated(codeString).then(response => {

                        console.log(response)
                        if (response) {


                            this.$nextTick(() => {

                                this.tag = response.data;
                                this.code = '';

                                // remove errors
                                observer.reset();

                                this.dialog = true;
                            });
                        }


                    }).catch(function (error) {
                        if (error.response && [401, 403, 419].includes(error.response.status)) {
                            userService.logout().then(() => {
                                store.dispatch('alert/error', i18n.t('You have been logged out due to inactivity'), { root: true });
                            })
                        }
                        else if (error.response && error.response.status === 401) {
                          store.dispatch('alert/error', error.response.data.error, { root: true });
                        }
                        else {
                            if (error.response && error.response.data && error.response.data.error) {
                                store.dispatch('alert/error', error.response.data.error, {root: true});
                            }
                            else {
                                store.dispatch('alert/error', i18n.t('Unknown error occurred'), {root: true});
                            }
                        }

                    });
                })


                // if (tag) {
                //     router.push('scanned/' + tag)
                // }
            },
            handleActivate () {

                store.dispatch('alert/clear');

                let observer = this.$refs.activateObserver;

                let that = this

                observer.validate().then(success => {
                    if (!success) {
                        return;
                    }

                    tagService.activate(this.tag.qr_code, this.myself, this.dependant, this.is_public).then(response => {

                        if (response) {
                            this.tag = {};
                            this.dialog = false;
                            store.dispatch('alert/success', i18n.t('Tag activated'), {root: true});
                        }
                    }).catch(function (error) {
                            console.log(error)
                            that.tag = {};
                            that.dialog = false;

                    });
                })
            },
            onReady() {
              this.playerReady = true
            },
            play () {
              this.$refs.player.play()
            },
            stop () {
              this.$refs.player.stop()
            },
        }
    }
</script>

<style scoped>
  ol {
    list-style: none;
    counter-reset: item;
    padding-left: 48px;
  }
  li {
    counter-increment: item;
    margin-bottom: 20px;
  }
  li:before {
    margin-right: 10px;
    margin-left: -38px;
    content: counter(item);
    background: #e5007f;
    border-radius: 100%;
    color: white;
    width: 1.7rem;
    text-align: center;
    display: inline-block;
  }
</style>
